import React from "react";
import * as Types from "../../../../../../../../types/__generated__/graphql";
import {withTextStyle} from "@components/Booking/LocationSelection/LocationRow/styles";

/**
 * Render a full address on one line if possible. If not, wrap it at the "normal" place
 * and add a trailing comma to the first line.
 *
 * At this point it's not clear whether this will be the "normal" way to render addresses...
 * need more features & mockups. It seems possible though.
 */

type Props = {
  address: {
    street?: string | null;
    street2?: string | null;
    zipcode?: string | null;
    state?: Types.UsStateAbbreviation | null;
    city?: string | null;
  };
  disabled: boolean;
};
const PaddedFullAddress = ({address: {street, street2, zipcode, state, city}, disabled}: Props) => {
  const firstLine = street2 ? `${street}, ${street2}` : street;
  const secondLine = `${city}, ${state}, ${zipcode}`;
  const className = withTextStyle("font-i text-sm", "text-gray-900", disabled);
  return (
    <span className={className}>
      <span className="whitespace-nowrap">{firstLine},</span>
      <wbr />
      <span className="whitespace-nowrap"> {secondLine}</span>
    </span>
  );
};
export default React.memo(PaddedFullAddress);
